import { Card, Grid, Skeleton, Stack, styled } from "@mui/material";

const MessageCardSkeletonContainer = styled(Card)(({ theme }) => ({
  padding: "16px 12px",
  border: `1px solid ${theme.palette.support[300]}`,
  borderRadius: 8,
  height: "100%",
  display: "flex",
  flexDirection: "column",
}));

const SkeletonWrapper = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

export interface MessageCardsSkeletonProps {
  count?: number;
  variant?: "grid" | "inline";
}

export function MessageCardsSkeleton({
  count = 3,
  variant = "grid",
}: MessageCardsSkeletonProps) {
  const skeletonContent = (
    <MessageCardSkeletonContainer>
      <Stack gap={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Skeleton variant="text" width="60%" height={24} />
          <Stack direction="row" alignItems="center" gap={1}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={80} height={40} />
          </Stack>
        </Stack>
        <Skeleton variant="rectangular" width="100%" height={1} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="100%" height={60} />
      </Stack>
    </MessageCardSkeletonContainer>
  );

  if (variant === "inline") {
    return (
      <>
        {Array.from({ length: count }).map((_, index) => (
          <SkeletonWrapper
            // biome-ignore lint/suspicious/noArrayIndexKey: Using index as key is acceptable here since the skeleton list is static
            key={`skeleton-message-${index}`}
          >
            {skeletonContent}
          </SkeletonWrapper>
        ))}
      </>
    );
  }

  return (
    <Grid container spacing={2.5}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid
          // biome-ignore lint/suspicious/noArrayIndexKey: Using index as key is acceptable here since the skeleton list is static
          key={`skeleton-message-${index}`}
          size={{
            xs: 12,
            md: 4,
            xl: 4,
          }}
        >
          {skeletonContent}
        </Grid>
      ))}
    </Grid>
  );
}
